import {apiClient} from '@common/http/query-client';
interface Response {
  status: string;
}
export async function checkoutStatus(id: string): Promise<Response> {
  return await apiClient.get(`checkout/${id}`).then(res => res.data);
}
